module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/header.component.css
// module id = ./src/app/modules/housekeeping/css/header.component.css
// module chunks = main